// Načte více řad (tsId / ghId) přes callback fetchOne.
//
// Čtení existujících dat z postgresu je thread-safe pro jakýkoli zdroj →
// stahuje se paralelně. Pro přepnutí na sériové stahování řad nastav
// PARALLEL_READ = false (ladění / throttle při hodně řadách).
//
// NEtýká se dotahování (to_fill / POST fill) — to je vždy sériové a řeší ho
// runToFill, ne tenhle helper.
const PARALLEL_READ = true

export async function fetchTsIds(tsIds, fetchOne, parallel = PARALLEL_READ) {
  if (parallel) return Promise.all(tsIds.map(fetchOne))
  const results = []
  for (const tsId of tsIds) results.push(await fetchOne(tsId))
  return results
}
